<template>
        <div class='selecionar-produto row'>
                <div class=' col-6 produtoinfo'>
                    <div class="nome">
                         {{produto.nome}}
                    </div>
                    <div class="preco">
                        R$ {{ produto.preco }}    
                        <div class='mt-2'> <small>disponível: {{produto.disponivel}}</small></div>
                    </div>
                </div>
                <div class='col-6 produtoquantidade' >
                        <quantidade-selector 
                            v-model="quantidade"
                            :max="produto.disponivel"
                            :unidade="produto.medida"
                            :increment="produto.incremento || 1"
                        />

                      
                </div>
                
        </div>
</template>


<script>
import QuantidadeSelector from '@/components/elementos/quantidade-selector'
export default {
        components:{
            QuantidadeSelector
        },

        data(){
            return {
                quantidade:0
            }
        },

        created:function(){

            this.quantidade = this.produto.quantidade

        },

        props:{
            produto:{
                default:{}
            }
        },

        computed:{
            // quantidade:{
            //     get:function(){
            //        return this.$store.getters.quantidadeProduto(this.produto.id)
            //     },
            //     set:function(qtd){
            //          this.$store.commit('updateCesta', {produto:this.produto, quantidade:qtd} )
            //     }
            // }
        },

        watch:{

            'produto':function(){
                     this.quantidade = this.produto.quantidade
            },
            
            quantidade:function(qtd){
                    console.log(this.produto)
                    console.log(qtd)
                    this.$store.commit('updateCesta', {produto:this.produto, quantidade:qtd} )
            },

        }

}

</script>

<style lang="stylus">

.selecionar-produto{
    
        display:flex;
        padding:1.5em 0.5em;

        border-top:1px dotted gray;

        .produtoinfo{
            text-align:left;
                
        }
}

</style>